"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FileContent = _interopRequireDefault(require("./FileContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FileAttachment = function FileAttachment(_ref) {
  var _ref$activity = _ref.activity;
  _ref$activity = _ref$activity === void 0 ? {} : _ref$activity;
  var _ref$activity$attachm = _ref$activity.attachments,
      attachments = _ref$activity$attachm === void 0 ? [] : _ref$activity$attachm,
      _ref$activity$channel = _ref$activity.channelData;
  _ref$activity$channel = _ref$activity$channel === void 0 ? {} : _ref$activity$channel;
  var _ref$activity$channel2 = _ref$activity$channel.attachmentSizes,
      attachmentSizes = _ref$activity$channel2 === void 0 ? [] : _ref$activity$channel2,
      attachment = _ref.attachment;
  var attachmentIndex = attachments.indexOf(attachment);
  var size = attachmentSizes[attachmentIndex];
  return _react.default.createElement(_FileContent.default, {
    fileName: attachment.name,
    href: attachment.contentUrl,
    size: size
  });
};

FileAttachment.propTypes = {
  activity: _propTypes.default.shape({
    attachment: _propTypes.default.array,
    channelData: _propTypes.default.shape({
      attachmentSizes: _propTypes.default.arrayOf(_propTypes.default.number)
    })
  }).isRequired,
  attachment: _propTypes.default.shape({
    contentUrl: _propTypes.default.string,
    name: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = FileAttachment;
exports.default = _default;